import { useState, useEffect } from "react";
import { visionURL } from "../config/environment";
import JsonApiService from "../services/jsonapiService";
import Jsona from "jsona";
import visionCallService from "../services/visionCallService";

const dataFormatter = new Jsona();

const instructorsApiService = async () =>
  new JsonApiService("instructors", {
    baseUrl: `${visionURL}/admin_console/api/content`,
    credentials: "include"
  });

const InstructorCandidatesApiService = async () =>
  new JsonApiService("instructor_candidates", {
    baseUrl: `${visionURL}/admin_console/api/content/instructors`,
    credentials: "include"
  });

export const useInstructors = () => {
  const [isUpdating, setIsUpdating] = useState(false);
  const updateInstructor = async (instructorId, instructorData) => {
    setIsUpdating(true);
    const service = await instructorsApiService();
    const response = await service
      .update(
        instructorId,
        visionCallService.serializeRequestBody(instructorData, "instructor", [
          "statusType"
        ])
      )
      .then(response => response.json());
    setIsUpdating(false);
    if (response.errors) {
      throw response.errors;
    } else {
      return {
        data: dataFormatter.deserialize(response),
        ...response.meta
      };
    }
  };
  return {
    getInstructors: async ({ sortBy, page, filters }) => {
      const service = await instructorsApiService();
      const response = await service
        .page(page)
        .sort(sortBy)
        .where(filters)
        .include(["statusType"])
        .all()
        .then(response => response.json());
      return {
        data: dataFormatter.deserialize(response),
        ...response.meta
      };
    },
    updateInstructor,
    isUpdating
  };
};

export const createInstructor = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  return {
    createNewInstructor: async data => {
      setIsSubmitting(true);
      const service = await instructorsApiService();
      const response = await service
        .create(JSON.stringify(data))
        .then(response => response.json());
      setIsSubmitting(false);
      return response;
    },
    isSubmitting
  };
};

export const useInstructorCandidates = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [instructorCandidates, setInstructorCandidates] = useState([]);

  const fetchInstructorCandidates = async () => {
    setIsLoading(true);
    const service = await InstructorCandidatesApiService();
    const response = await service
      .include(["location", "position"])
      .all()
      .then(response => response.json());
    setIsLoading(false);
    setInstructorCandidates(dataFormatter.deserialize(response));
  };

  useEffect(() => {
    fetchInstructorCandidates();
  }, []);

  return { instructorCandidates, isLoading, fetchInstructorCandidates };
};
